import script from "./SyncOverviewPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SyncOverviewPage.vue?vue&type=script&lang=ts&setup=true"

import "./SyncOverviewPage.vue?vue&type=style&index=0&id=fde62834&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fde62834"]])

export default __exports__